import { useAuth } from '@entities/auth'
import { SERVICE_NAME } from '@shared/constants/service'
import { FullscreenMenu } from '@shared/ui/fullscreen-menu'
import { Link } from '@tanstack/react-router'
import { useState } from 'react'
import { HiMiniBars3 } from 'react-icons/hi2'

export function HomeHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { isLoggedIn, user } = useAuth()

  return (
    <>
      <div className="sticky top-0 z-sticky bg-bg-base/80 backdrop-blur-md shadow-(--elevation-sm)">
        <header className="flex h-14 items-center justify-between px-4">
          <Link to="/" className="flex items-center cursor-pointer">
            <img src="/snack_logo.png" alt={SERVICE_NAME} className="h-4" />
          </Link>
          <button
            type="button"
            className="flex h-11 w-11 cursor-pointer items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-muted/30"
            aria-label="메뉴"
            onClick={() => {
              setIsMenuOpen(true)
            }}
          >
            <HiMiniBars3 className="text-2xl" />
          </button>
        </header>
      </div>
      <FullscreenMenu
        isOpen={isMenuOpen}
        onClose={() => {
          setIsMenuOpen(false)
        }}
        isLoggedIn={isLoggedIn}
        userName={user?.nickname}
      />
    </>
  )
}
